'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var manifest = [{
  stem: "add-circle",
  icon: "AddCircle"
}, {
  stem: "add-rectangle",
  icon: "AddRectangle"
}, {
  stem: "add",
  icon: "Add"
}, {
  stem: "app",
  icon: "App"
}, {
  stem: "arrow-down-rectangle",
  icon: "ArrowDownRectangle"
}, {
  stem: "arrow-down",
  icon: "ArrowDown"
}, {
  stem: "arrow-left",
  icon: "ArrowLeft"
}, {
  stem: "arrow-right",
  icon: "ArrowRight"
}, {
  stem: "arrow-up",
  icon: "ArrowUp"
}, {
  stem: "attach",
  icon: "Attach"
}, {
  stem: "backtop-rectangle",
  icon: "BacktopRectangle"
}, {
  stem: "backtop",
  icon: "Backtop"
}, {
  stem: "backward",
  icon: "Backward"
}, {
  stem: "barcode",
  icon: "Barcode"
}, {
  stem: "books",
  icon: "Books"
}, {
  stem: "browse-off",
  icon: "BrowseOff"
}, {
  stem: "browse",
  icon: "Browse"
}, {
  stem: "bulletpoint",
  icon: "Bulletpoint"
}, {
  stem: "calendar",
  icon: "Calendar"
}, {
  stem: "call",
  icon: "Call"
}, {
  stem: "caret-down-small",
  icon: "CaretDownSmall"
}, {
  stem: "caret-down",
  icon: "CaretDown"
}, {
  stem: "caret-left-small",
  icon: "CaretLeftSmall"
}, {
  stem: "caret-left",
  icon: "CaretLeft"
}, {
  stem: "caret-right-small",
  icon: "CaretRightSmall"
}, {
  stem: "caret-right",
  icon: "CaretRight"
}, {
  stem: "caret-up-small",
  icon: "CaretUpSmall"
}, {
  stem: "caret-up",
  icon: "CaretUp"
}, {
  stem: "cart",
  icon: "Cart"
}, {
  stem: "chart-bar",
  icon: "ChartBar"
}, {
  stem: "chart-bubble",
  icon: "ChartBubble"
}, {
  stem: "chart-pie",
  icon: "ChartPie"
}, {
  stem: "chart",
  icon: "Chart"
}, {
  stem: "chat",
  icon: "Chat"
}, {
  stem: "check-circle-filled",
  icon: "CheckCircleFilled"
}, {
  stem: "check-circle",
  icon: "CheckCircle"
}, {
  stem: "check-rectangle-filled",
  icon: "CheckRectangleFilled"
}, {
  stem: "check-rectangle",
  icon: "CheckRectangle"
}, {
  stem: "check",
  icon: "Check"
}, {
  stem: "chevron-down-circle",
  icon: "ChevronDownCircle"
}, {
  stem: "chevron-down-rectangle",
  icon: "ChevronDownRectangle"
}, {
  stem: "chevron-down",
  icon: "ChevronDown"
}, {
  stem: "chevron-left-circle",
  icon: "ChevronLeftCircle"
}, {
  stem: "chevron-left-double",
  icon: "ChevronLeftDouble"
}, {
  stem: "chevron-left-rectangle",
  icon: "ChevronLeftRectangle"
}, {
  stem: "chevron-left",
  icon: "ChevronLeft"
}, {
  stem: "chevron-right-circle",
  icon: "ChevronRightCircle"
}, {
  stem: "chevron-right-double",
  icon: "ChevronRightDouble"
}, {
  stem: "chevron-right-rectangle",
  icon: "ChevronRightRectangle"
}, {
  stem: "chevron-right",
  icon: "ChevronRight"
}, {
  stem: "chevron-up-circle",
  icon: "ChevronUpCircle"
}, {
  stem: "chevron-up-rectangle",
  icon: "ChevronUpRectangle"
}, {
  stem: "chevron-up",
  icon: "ChevronUp"
}, {
  stem: "circle",
  icon: "Circle"
}, {
  stem: "clear",
  icon: "Clear"
}, {
  stem: "close-circle-filled",
  icon: "CloseCircleFilled"
}, {
  stem: "close-circle",
  icon: "CloseCircle"
}, {
  stem: "close-rectangle",
  icon: "CloseRectangle"
}, {
  stem: "close",
  icon: "Close"
}, {
  stem: "cloud-download",
  icon: "CloudDownload"
}, {
  stem: "cloud-upload",
  icon: "CloudUpload"
}, {
  stem: "cloud",
  icon: "Cloud"
}, {
  stem: "code",
  icon: "Code"
}, {
  stem: "control-platform",
  icon: "ControlPlatform"
}, {
  stem: "creditcard",
  icon: "Creditcard"
}, {
  stem: "dashboard",
  icon: "Dashboard"
}, {
  stem: "delete",
  icon: "Delete"
}, {
  stem: "desktop",
  icon: "Desktop"
}, {
  stem: "discount-filled",
  icon: "DiscountFilled"
}, {
  stem: "discount",
  icon: "Discount"
}, {
  stem: "download",
  icon: "Download"
}, {
  stem: "edit-1",
  icon: "Edit1"
}, {
  stem: "edit",
  icon: "Edit"
}, {
  stem: "ellipsis",
  icon: "Ellipsis"
}, {
  stem: "enter",
  icon: "Enter"
}, {
  stem: "error-circle-filled",
  icon: "ErrorCircleFilled"
}, {
  stem: "error-circle",
  icon: "ErrorCircle"
}, {
  stem: "error",
  icon: "Error"
}, {
  stem: "file-add",
  icon: "FileAdd"
}, {
  stem: "file-copy",
  icon: "FileCopy"
}, {
  stem: "file-excel",
  icon: "FileExcel"
}, {
  stem: "file-icon",
  icon: "FileIcon"
}, {
  stem: "file-image",
  icon: "FileImage"
}, {
  stem: "file-paste",
  icon: "FilePaste"
}, {
  stem: "file-pdf",
  icon: "FilePdf"
}, {
  stem: "file-powerpoint",
  icon: "FilePowerpoint"
}, {
  stem: "file-unknown",
  icon: "FileUnknown"
}, {
  stem: "file-word",
  icon: "FileWord"
}, {
  stem: "file",
  icon: "File"
}, {
  stem: "filter-clear",
  icon: "FilterClear"
}, {
  stem: "filter",
  icon: "Filter"
}, {
  stem: "flag",
  icon: "Flag"
}, {
  stem: "folder-add",
  icon: "FolderAdd"
}, {
  stem: "folder-open",
  icon: "FolderOpen"
}, {
  stem: "folder",
  icon: "Folder"
}, {
  stem: "fork",
  icon: "Fork"
}, {
  stem: "format-horizontal-align-bottom",
  icon: "FormatHorizontalAlignBottom"
}, {
  stem: "format-horizontal-align-center",
  icon: "FormatHorizontalAlignCenter"
}, {
  stem: "format-horizontal-align-top",
  icon: "FormatHorizontalAlignTop"
}, {
  stem: "format-vertical-align-center",
  icon: "FormatVerticalAlignCenter"
}, {
  stem: "format-vertical-align-left",
  icon: "FormatVerticalAlignLeft"
}, {
  stem: "format-vertical-align-right",
  icon: "FormatVerticalAlignRight"
}, {
  stem: "forward",
  icon: "Forward"
}, {
  stem: "fullscreen-exit",
  icon: "FullscreenExit"
}, {
  stem: "fullscreen",
  icon: "Fullscreen"
}, {
  stem: "gender-female",
  icon: "GenderFemale"
}, {
  stem: "gender-male",
  icon: "GenderMale"
}, {
  stem: "gift",
  icon: "Gift"
}, {
  stem: "heart-filled",
  icon: "HeartFilled"
}, {
  stem: "heart",
  icon: "Heart"
}, {
  stem: "help-circle-filled",
  icon: "HelpCircleFilled"
}, {
  stem: "help-circle",
  icon: "HelpCircle"
}, {
  stem: "help",
  icon: "Help"
}, {
  stem: "history",
  icon: "History"
}, {
  stem: "home",
  icon: "Home"
}, {
  stem: "hourglass",
  icon: "Hourglass"
}, {
  stem: "image-error",
  icon: "ImageError"
}, {
  stem: "image",
  icon: "Image"
}, {
  stem: "info-circle-filled",
  icon: "InfoCircleFilled"
}, {
  stem: "info-circle",
  icon: "InfoCircle"
}, {
  stem: "internet",
  icon: "Internet"
}, {
  stem: "jump",
  icon: "Jump"
}, {
  stem: "laptop",
  icon: "Laptop"
}, {
  stem: "layers",
  icon: "Layers"
}, {
  stem: "link-unlink",
  icon: "LinkUnlink"
}, {
  stem: "link",
  icon: "Link"
}, {
  stem: "loading",
  icon: "Loading"
}, {
  stem: "location",
  icon: "Location"
}, {
  stem: "lock-off",
  icon: "LockOff"
}, {
  stem: "lock-on",
  icon: "LockOn"
}, {
  stem: "login",
  icon: "Login"
}, {
  stem: "logo-android",
  icon: "LogoAndroid"
}, {
  stem: "logo-apple-filled",
  icon: "LogoAppleFilled"
}, {
  stem: "logo-apple",
  icon: "LogoApple"
}, {
  stem: "logo-chrome-filled",
  icon: "LogoChromeFilled"
}, {
  stem: "logo-chrome",
  icon: "LogoChrome"
}, {
  stem: "logo-codepen",
  icon: "LogoCodepen"
}, {
  stem: "logo-github-filled",
  icon: "LogoGithubFilled"
}, {
  stem: "logo-github",
  icon: "LogoGithub"
}, {
  stem: "logo-ie-filled",
  icon: "LogoIeFilled"
}, {
  stem: "logo-ie",
  icon: "LogoIe"
}, {
  stem: "logo-qq",
  icon: "LogoQq"
}, {
  stem: "logo-wechat",
  icon: "LogoWechat"
}, {
  stem: "logo-wecom",
  icon: "LogoWecom"
}, {
  stem: "logo-windows-filled",
  icon: "LogoWindowsFilled"
}, {
  stem: "logo-windows",
  icon: "LogoWindows"
}, {
  stem: "logout",
  icon: "Logout"
}, {
  stem: "mail",
  icon: "Mail"
}, {
  stem: "menu-fold",
  icon: "MenuFold"
}, {
  stem: "menu-unfold",
  icon: "MenuUnfold"
}, {
  stem: "minus-circle-filled",
  icon: "MinusCircleFilled"
}, {
  stem: "minus-circle",
  icon: "MinusCircle"
}, {
  stem: "minus-rectangle",
  icon: "MinusRectangle"
}, {
  stem: "mirror",
  icon: "Mirror"
}, {
  stem: "mobile-vibrate",
  icon: "MobileVibrate"
}, {
  stem: "mobile",
  icon: "Mobile"
}, {
  stem: "money-circle",
  icon: "MoneyCircle"
}, {
  stem: "more",
  icon: "More"
}, {
  stem: "move",
  icon: "Move"
}, {
  stem: "next",
  icon: "Next"
}, {
  stem: "notification-filled",
  icon: "NotificationFilled"
}, {
  stem: "notification",
  icon: "Notification"
}, {
  stem: "order-adjustment-column",
  icon: "OrderAdjustmentColumn"
}, {
  stem: "order-ascending",
  icon: "OrderAscending"
}, {
  stem: "order-descending",
  icon: "OrderDescending"
}, {
  stem: "page-first",
  icon: "PageFirst"
}, {
  stem: "page-last",
  icon: "PageLast"
}, {
  stem: "pause-circle-filled",
  icon: "PauseCircleFilled"
}, {
  stem: "photo",
  icon: "Photo"
}, {
  stem: "pin-filled",
  icon: "PinFilled"
}, {
  stem: "pin",
  icon: "Pin"
}, {
  stem: "play-circle-filled",
  icon: "PlayCircleFilled"
}, {
  stem: "play-circle-stroke",
  icon: "PlayCircleStroke"
}, {
  stem: "play-circle",
  icon: "PlayCircle"
}, {
  stem: "play",
  icon: "Play"
}, {
  stem: "poweroff",
  icon: "Poweroff"
}, {
  stem: "precise-monitor",
  icon: "PreciseMonitor"
}, {
  stem: "previous",
  icon: "Previous"
}, {
  stem: "print",
  icon: "Print"
}, {
  stem: "qrcode",
  icon: "Qrcode"
}, {
  stem: "queue",
  icon: "Queue"
}, {
  stem: "rectangle",
  icon: "Rectangle"
}, {
  stem: "refresh",
  icon: "Refresh"
}, {
  stem: "relativity",
  icon: "Relativity"
}, {
  stem: "remove",
  icon: "Remove"
}, {
  stem: "rollback",
  icon: "Rollback"
}, {
  stem: "rollfront",
  icon: "Rollfront"
}, {
  stem: "root-list",
  icon: "RootList"
}, {
  stem: "rotation",
  icon: "Rotation"
}, {
  stem: "round",
  icon: "Round"
}, {
  stem: "save",
  icon: "Save"
}, {
  stem: "scan",
  icon: "Scan"
}, {
  stem: "search",
  icon: "Search"
}, {
  stem: "secured",
  icon: "Secured"
}, {
  stem: "server",
  icon: "Server"
}, {
  stem: "service",
  icon: "Service"
}, {
  stem: "setting",
  icon: "Setting"
}, {
  stem: "share",
  icon: "Share"
}, {
  stem: "shop",
  icon: "Shop"
}, {
  stem: "slash",
  icon: "Slash"
}, {
  stem: "sound",
  icon: "Sound"
}, {
  stem: "star-filled",
  icon: "StarFilled"
}, {
  stem: "star",
  icon: "Star"
}, {
  stem: "stop-circle-1",
  icon: "StopCircle1"
}, {
  stem: "stop-circle-filled",
  icon: "StopCircleFilled"
}, {
  stem: "stop-circle",
  icon: "StopCircle"
}, {
  stem: "stop",
  icon: "Stop"
}, {
  stem: "swap-left",
  icon: "SwapLeft"
}, {
  stem: "swap-right",
  icon: "SwapRight"
}, {
  stem: "swap",
  icon: "Swap"
}, {
  stem: "thumb-down",
  icon: "ThumbDown"
}, {
  stem: "thumb-up",
  icon: "ThumbUp"
}, {
  stem: "time-filled",
  icon: "TimeFilled"
}, {
  stem: "time",
  icon: "Time"
}, {
  stem: "tips",
  icon: "Tips"
}, {
  stem: "tools",
  icon: "Tools"
}, {
  stem: "unfold-less",
  icon: "UnfoldLess"
}, {
  stem: "unfold-more",
  icon: "UnfoldMore"
}, {
  stem: "upload",
  icon: "Upload"
}, {
  stem: "usb",
  icon: "Usb"
}, {
  stem: "user-add",
  icon: "UserAdd"
}, {
  stem: "user-avatar",
  icon: "UserAvatar"
}, {
  stem: "user-circle",
  icon: "UserCircle"
}, {
  stem: "user-clear",
  icon: "UserClear"
}, {
  stem: "user-talk",
  icon: "UserTalk"
}, {
  stem: "user",
  icon: "User"
}, {
  stem: "usergroup-add",
  icon: "UsergroupAdd"
}, {
  stem: "usergroup-clear",
  icon: "UsergroupClear"
}, {
  stem: "usergroup",
  icon: "Usergroup"
}, {
  stem: "video",
  icon: "Video"
}, {
  stem: "view-column",
  icon: "ViewColumn"
}, {
  stem: "view-list",
  icon: "ViewList"
}, {
  stem: "view-module",
  icon: "ViewModule"
}, {
  stem: "wallet",
  icon: "Wallet"
}, {
  stem: "wifi",
  icon: "Wifi"
}, {
  stem: "zoom-in",
  icon: "ZoomIn"
}, {
  stem: "zoom-out",
  icon: "ZoomOut"
}];

exports.manifest = manifest;
//# sourceMappingURL=manifest.js.map
